import React from 'react';
import type { NamePath } from '@xbcb/ui-types';
import PgaDisclaimAiStatus from 'components/PgaDisclaimAiStatus';
import PgaDisclaimRecommendation from 'components/PgaDisclaimRecommendation';
import { useComplianceRecommendation } from 'libs/hooks';

export interface PgaDisclaimSectionProps {
  lineNamePath: NamePath;
  fullNamePath: NamePath;
  pgaFlag: string;
  agencyName: string;
}

// Wraps the PGA Disclaim AI status/recommendation for a single flag: renders the
// plain status banner when there's nothing to act on ('none'), otherwise the
// accept/decline recommendation card.
const PgaDisclaimSection: React.FC<PgaDisclaimSectionProps> = ({
  lineNamePath,
  fullNamePath,
  pgaFlag,
  agencyName,
}) => {
  const { status, view, details, accept, decline } =
    useComplianceRecommendation({ lineNamePath, fullNamePath, pgaFlag });

  return view === 'none' ? (
    <PgaDisclaimAiStatus
      status={status}
      agencyName={agencyName}
      rationale={details.reason}
    />
  ) : (
    <PgaDisclaimRecommendation
      view={view}
      reason={details.reason}
      detailsLoading={details.loading}
      onAccept={accept}
      onDecline={decline}
    />
  );
};

export default PgaDisclaimSection;
